// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2XQSg","column":"style_column__l6MM_","title":"style_title__r64Gs","item":"style_item__3TLYp"};